define("shared/components/shared/collapsable-info-card", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "shared/utils/constants/keys", "shared/utils/handle-key-up"], function (_exports, _component, _templateFactory, _object, _utils, _component2, _tracking, _keys, _handleKeyUp) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _handleToggleActions;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"shared/utils/constants/keys",0,"shared/utils/handle-key-up"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cIC--card" data-test-id="collapsable-info-card" ...attributes>
    <div class="cIC--cardHeader">
      <p class="cIC--cardHeader__title">{{@title}}</p>
      {{! template-lint-disable no-pointer-down-event-binding }}
      <span
        class="cIC--cardHeader__icon {{@qaClass}}"
        {{on "click" this.toggleCollapsed}}
        {{on "keyup" this.toggleMultiCalProfileKeyboard}}
      >
        {{#if this.isCollapsed}}
          {{svg-jar "add" class="o--icon o--icon--light" data-test-id="expand" role="button" tabindex="0"}}
        {{else}}
          {{svg-jar "minus" class="o--icon o--icon--light" data-test-id="collapse" role="button" tabindex="0"}}
        {{/if}}
      </span>
    </div>
    {{#unless this.isCollapsed}}
      <div class="cIC--cardBody" data-test-id="collapsable-info-card-content">
        <div>
          {{yield}}
        </div>
      </div>
    {{/unless}}
  </div>
  */
  {
    "id": "9rXzhuE9",
    "block": "[[[11,0],[24,0,\"cIC--card\"],[24,\"data-test-id\",\"collapsable-info-card\"],[17,1],[12],[1,\"\\n  \"],[10,0],[14,0,\"cIC--cardHeader\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"cIC--cardHeader__title\"],[12],[1,[30,2]],[13],[1,\"\\n\"],[1,\"    \"],[11,1],[16,0,[29,[\"cIC--cardHeader__icon \",[30,3]]]],[4,[38,0],[\"click\",[30,0,[\"toggleCollapsed\"]]],null],[4,[38,0],[\"keyup\",[30,0,[\"toggleMultiCalProfileKeyboard\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isCollapsed\"]],[[[1,\"        \"],[1,[28,[35,2],[\"add\"],[[\"class\",\"data-test-id\",\"role\",\"tabindex\"],[\"o--icon o--icon--light\",\"expand\",\"button\",\"0\"]]]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,2],[\"minus\"],[[\"class\",\"data-test-id\",\"role\",\"tabindex\"],[\"o--icon o--icon--light\",\"collapse\",\"button\",\"0\"]]]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[51,[30,0,[\"isCollapsed\"]]],[[[1,\"    \"],[10,0],[14,0,\"cIC--cardBody\"],[14,\"data-test-id\",\"collapsable-info-card-content\"],[12],[1,\"\\n      \"],[10,0],[12],[1,\"\\n        \"],[18,4,null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\",\"@title\",\"@qaClass\",\"&default\"],false,[\"on\",\"if\",\"svg-jar\",\"unless\",\"yield\"]]",
    "moduleName": "shared/components/shared/collapsable-info-card.hbs",
    "isStrictMode": false
  });

  let CollapsableInfoCardComponent = (_class = (_handleToggleActions = /*#__PURE__*/new WeakSet(), class CollapsableInfoCardComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _classPrivateMethodInitSpec(this, _handleToggleActions);

      _initializerDefineProperty(this, "isCollapsed", _descriptor, this);
    }

    toggleCollapsed() {
      this.isCollapsed = !this.isCollapsed;

      _classPrivateMethodGet(this, _handleToggleActions, _handleToggleActions2).call(this);
    }

    toggleMultiCalProfileKeyboard(event) {
      (0, _handleKeyUp.default)(event, _keys.default.SPACE, () => {
        this.isCollapsed = !this.isCollapsed;

        _classPrivateMethodGet(this, _handleToggleActions, _handleToggleActions2).call(this);
      });
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isCollapsed", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleCollapsed", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCollapsed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMultiCalProfileKeyboard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMultiCalProfileKeyboard"), _class.prototype)), _class);
  _exports.default = CollapsableInfoCardComponent;

  function _handleToggleActions2() {
    if (this.isCollapsed && (0, _utils.isPresent)(this.args.onCollapsedAction)) {
      this.args.onCollapsedAction();
    }
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CollapsableInfoCardComponent);
});